// src/state/settings/users/types.ts
var SET_USERS = "SET_USERS";
var SET_CLOCK_IN = "SET_CLOCK_IN";
var SET_BREAK_IN = "SET_BREAK_IN";
var UPDATE_TIME_SUMMARY = "UPDATE_TIME_SUMMARY";
var UPDATE_TIME_SUMMARY_WS = "UPDATE_TIME_SUMMARY_WS";
var UPDATE_RECENT_ORDERS = "UPDATE_RECENT_ORDERS";
var UPDATE_SINGLE_TABLE = "UPDATE_SINGLE_TABLE";
var UPDATE_RECENT_ORDERS_WS = "UPDATE_RECENT_ORDERS_WS";
var UPDATE_LOGGED_IN_RECENT_ORDERS = "UPDATE_LOGGED_IN_RECENT_ORDERS";
var UPDATE_LOGGED_IN_RECENT_ORDERS_WS = "UPDATE_LOGGED_IN_RECENT_ORDERS_WS";
var UserStatus = /* @__PURE__ */ ((UserStatus2) => {
  UserStatus2["ACTIVE"] = "active";
  UserStatus2["INACTIVE"] = "inactive";
  UserStatus2["ON_BREAK"] = "on break";
  return UserStatus2;
})(UserStatus || {});

export { SET_BREAK_IN, SET_CLOCK_IN, SET_USERS, UPDATE_LOGGED_IN_RECENT_ORDERS, UPDATE_LOGGED_IN_RECENT_ORDERS_WS, UPDATE_RECENT_ORDERS, UPDATE_RECENT_ORDERS_WS, UPDATE_SINGLE_TABLE, UPDATE_TIME_SUMMARY, UPDATE_TIME_SUMMARY_WS, UserStatus };
